/* @jsx h */
/* eslint-disable react/react-in-jsx-scope */
// eslint-disable-next-line no-unused-vars
import { h, render } from 'preact';
import { AppHeader } from './component';

export const createView = ({ container }) => {
  const renderNull = () => {
    render(null, container);
  };

  return {
    render({
      state: {
        isHidden,
        entityBrandings,
        showPoweredBy,
        poweredByUrl,
        onSignIn,
        logoClickEnabled,
        moverDropdown,
        showMoverDropdown,
        disableMoverDropdown,
      },
      actions: { onLogoClick, routerGo },
      analytics,
    }) {
      isHidden
        ? renderNull()
        : render(
            <AppHeader
              {...entityBrandings}
              onSignIn={onSignIn}
              showPoweredBy={showPoweredBy}
              poweredByUrl={poweredByUrl}
              logoClickEnabled={logoClickEnabled}
              onLogoClick={onLogoClick}
              routerGo={routerGo}
              analytics={analytics}
              moverDropdown={moverDropdown}
              showMoverDropdown={showMoverDropdown}
              disableMoverDropdown={disableMoverDropdown}
            />,
            container
          );
    },
    destroy() {
      renderNull();
    },
  };
};
